module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "pubitCssCls1"
  }), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls1 Apple-style-span sgc-1"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls11"
  }, [_c('span', {
    staticClass: "pubitCssCls12"
  }, [_vm._v("The Leviticus Mission")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls13"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Copyright © 2011, by L.D. Knorr.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls13"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Cover Copyright © 2011 Sunbury Press.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls13"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls13"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls15"
  }, [_c('span', {
    staticClass: "pubitCssCls16"
  }, [_vm._v("NOTE: This is a work of fiction. Names, characters, places and incidents are the product of the author's imagination or are used fictitiously, and any resemblance to actual persons, living or dead, business establishments, events or locales is entirely coincidental.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls15"
  }, [_c('span', {
    staticClass: "pubitCssCls17"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls15"
  }, [_c('span', {
    staticClass: "pubitCssCls17"
  }, [_vm._v("All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever. For information contact Sunbury Press, Inc., Subsidiary Rights Dept., 2200 Market St., Camp Hill, PA 17011 USA or legal@sunburypress.com.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls15"
  }, [_c('span', {
    staticClass: "pubitCssCls17"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls15"
  }, [_c('span', {
    staticClass: "pubitCssCls17"
  }, [_vm._v("For information about special discounts for bulk purchases, please contact Sunbury Press, Inc. Wholesale Dept. at (717) 254-7274 or orders@sunburypress.com.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls15"
  }, [_c('span', {
    staticClass: "pubitCssCls18"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls15"
  }, [_c('span', {
    staticClass: "pubitCssCls17"
  }, [_vm._v("To request one of our authors for speaking engagements or book signings, please contact Sunbury Press, Inc. Publicity Dept. at publicity@sunburypress.com.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls13"
  }, [_c('span', {
    staticClass: "pubitCssCls19"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls13"
  }, [_c('span', {
    staticClass: "pubitCssCls20"
  }, [_vm._v("FIRST SUNBURY PRESS EDITION")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls13"
  }, [_c('span', {
    staticClass: "pubitCssCls21"
  }, [_vm._v("Printed in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls13"
  }, [_c('span', {
    staticClass: "pubitCssCls20"
  }, [_vm._v("October 2011")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls13"
  }, [_c('span', {
    staticClass: "pubitCssCls19"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls13"
  }, [_c('span', {
    staticClass: "pubitCssCls22"
  }, [_vm._v("ISBN")]), _vm._v(" "), _c('span', {
    staticClass: "pubitCssCls23"
  }, [_vm._v("978-1-934597-54-5")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls13"
  }, [_c('span', {
    staticClass: "pubitCssCls20"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls13"
  }, [_c('span', {
    staticClass: "pubitCssCls20"
  }, [_vm._v("Published by:")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls13"
  }, [_c('span', {
    staticClass: "pubitCssCls22"
  }, [_vm._v("Sunbury Press")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls13"
  }, [_c('span', {
    staticClass: "pubitCssCls20"
  }, [_vm._v("Camp Hill, PA")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls13"
  }, [_c('span', {
    staticClass: "pubitCssCls20"
  }, [_vm._v("www.sunburypress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls4"
  }, [_c('span', {
    staticClass: "pubitCssCls24"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls4"
  }, [_c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls1"
  }, [_c('span', {
    staticClass: "pubitCssCls25"
  }, [_vm._v("Camp Hill, Pennsylvania   USA")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6540914","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0001.vue
// module id = 60
// module chunks = 0